export const timezones = [
  'UTC',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'America/Adak',
  'America/Toronto',
  'America/Vancouver',
  'America/Mexico_City',
  'America/Monterrey',
  'America/Guatemala',
  'America/Managua',
  'America/San_Jose',
  'America/Panama',
  'America/Havana',
  'America/Santo_Domingo',
  'America/Caracas',
  'America/Bogota',
  'America/Lima',
  'America/La_Paz',
  'America/Santiago',
  'America/Asuncion',
  'America/Montevideo',
  'America/Buenos_Aires',
  'America/Sao_Paulo',
  'America/Fortaleza',
  'America/Recife',
  'America/Manaus',
  'America/Cayenne',
  'Europe/London',
  'Europe/Dublin',
  'Europe/Lisbon',
  'Europe/Madrid',
  'Europe/Paris',
  'Europe/Brussels',
  'Europe/Amsterdam',
  'Europe/Berlin',
  'Europe/Rome',
  'Europe/Vienna',
  'Europe/Prague',
  'Europe/Warsaw',
  'Europe/Budapest',
  'Europe/Bucharest',
  'Europe/Sofia',
  'Europe/Athens',
  'Europe/Helsinki',
  'Europe/Stockholm',
  'Europe/Oslo',
  'Europe/Copenhagen',
  'Europe/Riga',
  'Europe/Tallinn',
  'Europe/Vilnius',
  'Europe/Kiev',
  'Europe/Moscow',
  'Europe/Istanbul',
  'Asia/Dubai',
  'Asia/Kuwait',
  'Asia/Baghdad',
  'Asia/Riyadh',
  'Asia/Tehran',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Dhaka',
  'Asia/Colombo',
  'Asia/Kathmandu',
  'Asia/Yangon',
  'Asia/Bangkok',
  'Asia/Ho_Chi_Minh',
  'Asia/Jakarta',
  'Asia/Singapore',
  'Asia/Kuala_Lumpur',
  'Asia/Manila',
  'Asia/Hong_Kong',
  'Asia/Shanghai',
  'Asia/Taipei',
  'Asia/Seoul',
  'Asia/Tokyo',
  'Asia/Ulaanbaatar',
  'Asia/Vladivostok',
  'Asia/Yakutsk',
  'Asia/Irkutsk',
  'Asia/Krasnoyarsk',
  'Asia/Novosibirsk',
  'Asia/Tashkent',
  'Asia/Almaty',
  'Asia/Baku',
  'Asia/Yerevan',
  'Asia/Tbilisi',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Africa/Lagos',
  'Africa/Nairobi',
  'Africa/Casablanca',
  'Africa/Addis_Ababa',
  'Africa/Accra',
  'Africa/Dar_es_Salaam',
  'Australia/Sydney',
  'Australia/Melbourne',
  'Australia/Brisbane',
  'Australia/Perth',
  'Australia/Adelaide',
  'Australia/Darwin',
  'Australia/Hobart',
  'Pacific/Auckland',
  'Pacific/Fiji',
  'Pacific/Honolulu',
  'Pacific/Guam',
  'Pacific/Port_Moresby',
  'Pacific/Apia',
  'Pacific/Tongatapu',
] as const

export const dateFormats = [
  { value: 'Y-m-d', label: 'YYYY-MM-DD (2025-11-07)' },
  { value: 'm/d/Y', label: 'MM/DD/YYYY (11/07/2025)' },
  { value: 'd/m/Y', label: 'DD/MM/YYYY (07/11/2025)' },
  { value: 'F j, Y', label: 'Month Day, Year (November 7, 2025)' },
] as const

export const timeFormats = [
  { value: 'H:i:s', label: '24-hour (14:30:00)' },
  { value: 'h:i:s A', label: '12-hour (02:30:00 PM)' },
] as const

